module.exports = __webpack_public_path__ + "static/volt-e100e2ba3c691a89df3639f80994ebfa.jpg";